CF.ready(function() {

  const DEBUG = false; // ← 本番はfalse
  const log = (...args) => DEBUG && console.log(...args);

  const wrappers = document.querySelectorAll('.cf-date-field--inline-inputs');
  const zipInput = document.querySelector('[name="default_address.zip"]');

  // =========================
  // 生年月日 日本語化
  // =========================
  if (wrappers.length) {
    wrappers.forEach(wrapper => {
      const selects = wrapper.querySelectorAll('select');
      if (selects.length !== 3) return;

      const [year, month, day] = selects;

      if (year.options[0]) year.options[0].textContent = '年';
      if (month.options[0]) month.options[0].textContent = '月';
      if (day.options[0]) day.options[0].textContent = '日';
    });
  }

  if (!zipInput) return;

  // =========================
  // 郵便番号処理
  // =========================
  let timer;
  let lastZip = null;

  const prefMap = {
    '北海道': 'Hokkaidō','青森県': 'Aomori','岩手県': 'Iwate','宮城県': 'Miyagi',
    '秋田県': 'Akita','山形県': 'Yamagata','福島県': 'Fukushima','茨城県': 'Ibaraki',
    '栃木県': 'Tochigi','群馬県': 'Gunma','埼玉県': 'Saitama','千葉県': 'Chiba',
    '東京都': 'Tōkyō','神奈川県': 'Kanagawa','新潟県': 'Niigata','富山県': 'Toyama',
    '石川県': 'Ishikawa','福井県': 'Fukui','山梨県': 'Yamanashi','長野県': 'Nagano',
    '岐阜県': 'Gifu','静岡県': 'Shizuoka','愛知県': 'Aichi','三重県': 'Mie',
    '滋賀県': 'Shiga','京都府': 'Kyōto','大阪府': 'Ōsaka','兵庫県': 'Hyōgo',
    '奈良県': 'Nara','和歌山県': 'Wakayama','鳥取県': 'Tottori','島根県': 'Shimane',
    '岡山県': 'Okayama','広島県': 'Hiroshima','山口県': 'Yamaguchi','徳島県': 'Tokushima',
    '香川県': 'Kagawa','愛媛県': 'Ehime','高知県': 'Kōchi','福岡県': 'Fukuoka',
    '佐賀県': 'Saga','長崎県': 'Nagasaki','熊本県': 'Kumamoto','大分県': 'Ōita',
    '宮崎県': 'Miyazaki','鹿児島県': 'Kagoshima','沖縄県': 'Okinawa'
  };

  zipInput.addEventListener('input', (e) => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const value = e.target.value;

      if (!value.match(/^\d{3}-?\d{4}$/)) return;

      // 同じ郵便番号ならスキップ
      if (value === lastZip) return;
      lastZip = value;

      log('fetch開始:', value);

      // ローディング表示（必要ならUIに反映）
      zipInput.classList.add('is-loading');

      fetch('https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value)
        .then(res => res.json())
        .then(data => {
          log('API結果:', data);

          if (!data.results) return;

          const pref = data.results[0].address1;
          const city = data.results[0].address2;
          const street = data.results[0].address3;

          const cfForm = document.querySelector('form[data-cf-form]')?.cfForm;
          if (!cfForm) {
            log('cfForm not found');
            return;
          }

          const mappedPref = prefMap[pref] || pref;

          cfForm.setFieldValue("default_address.province", mappedPref);
          cfForm.setFieldValue("default_address.city", city + street);

        })
        .catch(err => console.error('郵便番号APIエラー:', err))
        .finally(() => {
          zipInput.classList.remove('is-loading');
        });

    }, 300);
  });

  // =========================
  // エラーメッセージ削除
  // =========================
  function removeErrors(target = document) {
    target.querySelectorAll('.cf-field-errors li').forEach(li => {
      if (li.textContent.trim() === '５文字以上で入力してください') {
        li.style.display = 'none';
      }
    });
  }

  removeErrors();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches('.cf-field-errors') || node.querySelector('.cf-field-errors')) {
          removeErrors(node);
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});